import getProjectName from 'portal-modules/common/utils/get-project-name'
const projectName = getProjectName()
export default () => ({
  isTP: projectName == 'tp',
  isNotTP: projectName != 'tp',
  isRP: projectName == 'rp' || projectName == undefined,
  isNotRP: !(projectName == 'rp' || projectName == undefined),
  isRH: projectName == 'rh',
  isNotRH: projectName != 'rh',
})
